import React, { useMemo } from 'react';

export function formatNumber(
  num?: number | null,
  fractionDigits?: number
): string | number | null | undefined {
  if (num !== 0 && !num) return num;

  return num || fractionDigits
    ? (num || 0).toLocaleString('en-US', {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
      })
    : num;
}

export const FormattedNumber: React.FC<{
  num?: number | null;
  fractionDigits?: number;
}> = ({ num, fractionDigits }) => {
  const formatted = useMemo(() => formatNumber(num, fractionDigits), [num, fractionDigits]);
  return <>{formatted}</>;
};
